export function calcIRR(cashflows) {
  if (!cashflows?.length) return NaN;
  let hasNeg = false;
  let hasPos = false;
  for (const v of cashflows) {
    if (v < 0) hasNeg = true;
    if (v > 0) hasPos = true;
  }
  if (!hasNeg || !hasPos) return NaN;

  let r = 0.01;
  for (let iter = 0; iter < 200; iter++) {
    let npv = 0;
    let dnpv = 0;
    for (let t = 0; t < cashflows.length; t++) {
      const denom = (1 + r) ** t;
      npv += cashflows[t] / denom;
      if (t > 0) dnpv += (-t * cashflows[t]) / (1 + r) ** (t + 1);
    }
    if (Math.abs(npv) < 0.01) break;
    if (Math.abs(dnpv) < 1e-10) break;
    const newR = r - npv / dnpv;
    if (!Number.isFinite(newR)) return NaN;
    if (Math.abs(newR - r) < 1e-9) {
      r = newR;
      break;
    }
    r = newR;
    if (r <= -0.999) r = -0.999;
  }
  if (r <= -1) return -1;
  return (1 + r) ** 12 - 1;
}
